import EzModalController from 'layouts/modal/modal-controller';
import events from 'lib/events';
import { triggerCustomEvent, showHideItems } from 'lib/helpers';

import { sanitizeTerm } from 'lib/search-helpers';
import FuzzySet from 'fuzzyset.js';
import { ajaxGet } from 'lib/ajax-helpers';

export default class CollectionsModalController extends EzModalController {
  static targets = [
    'collectionsList',
    'collectionsListItem',
    'saveButton',
  ];

  static values = {
    initialModalLoad: Number,
    totalCollections: Number,
  }

  connect() {
    super.connect();

    this.compileCollectionsList();

    this.requestOtherCollections();

    this.searchForm = document.querySelector('[data-controller="collections-search-form"]');

    this.searchForm.addEventListener(events.collections.search_collections, this.searchCollections);

    window.addEventListener('CloseCollectionModal', this.closeCollectionsModal);
  }

  disconnect() {
    this.searchForm.removeEventListener(events.collections.search_collections, this.searchCollections);

    window.removeEventListener('CloseCollectionModal', this.closeCollectionsModal);

    super.disconnect();
  }

  closeCollectionsModal = (event) => {
    this.triggerClose(event);
  }

  compileCollectionsList() {
    this.collections = document.getElementsByClassName('collections-list__item__name');

    this.collectionsListArr = [...this.collections].map(
      (collection) => sanitizeTerm(collection.textContent) || sanitizeTerm(collection.innerText),
    );

    this.fuzzySearch = FuzzySet(this.collectionsListArr, false);
  }

  searchCollections = (event) => {
    if (sanitizeTerm(event.target.value).length) {
      this.saveButtonTarget.classList.remove('is-disabled');
    } else {
      this.saveButtonTarget.classList.add('is-disabled');
    }

    this.filterCollections(sanitizeTerm(event.target.value));
  }

  filterCollections(search) {
    const results = this.fuzzySearch.get(search, null, 0.2);

    showHideItems(this.collectionsListItemTargets, 'show', 'flex');

    if (search) showHideItems(this.collectionsListItemTargets, 'hide');

    if (results) {
      results.forEach((result) => {
        const collectionName = sanitizeTerm(result[1]);
        const matchingEls = this.collectionsListTarget.querySelectorAll(`[data-collection-name*="${collectionName}"]`);

        if (matchingEls) {
          showHideItems(matchingEls, 'show', 'flex');
        }
      });
    }
  }

  requestOtherCollections() {
    if (this.totalCollectionsValue <= this.collections.length) return;

    this.collectionsListTarget.insertAdjacentHTML('beforeend', '<div class="ez-spinner ez-spinner--sm"></div>');

    ajaxGet('/account/request_more_collections',
      (response) => {
        this.collectionsListTarget.querySelector('.ez-spinner').remove();
        this.collectionsListTarget.insertAdjacentHTML('beforeend', response.data);

        this.compileCollectionsList();

        triggerCustomEvent(events.collections.search_collections, {}, document.querySelector('.collections-search-form'));
      },
      (error) => {
        console.error(error); // eslint-disable-line no-console
      },
      { params: { offset: true, resource_id: this.element.querySelector('#collection_resource_id').value } });
  }
}
